import revive_payload_client_4sVQNw7RlN from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/node_modules/nuxt/dist/app/plugins/payload.client.js";
import plugin_vue3_A0OWXRrUgq from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_t2GMTTFnMT from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/node_modules/@nuxtjs/device/dist/runtime/plugin.mjs";
import chunk_reload_client_UciE0i6zes from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import index_NoOeBbAe38 from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/plugins/vuetify/index.js";
import index_HYtSsfhyFh from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/plugins/iconify/index.js";
import index_O6aXp1lQoC from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/plugins/i18n/index.js";
import datePicker_client_lfJHa2xpnu from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/plugins/datePicker.client.js";
import layouts_OBoGUkHiof from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/plugins/layouts.js";
import leaflet_client_trb2AG60Fs from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/plugins/leaflet.client.js";
import navigation_tracker_client_1cOcci8PxC from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/plugins/navigation-tracker.client.js";
import persistent_session_client_LrXxtlE9h7 from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/plugins/persistent-session.client.js";
import vue3_toastify_zPoFw264mR from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/plugins/vue3-toastify.js";
import webfontloader_client_Jql8Gs55fp from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/plugins/webfontloader.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_t2GMTTFnMT,
  chunk_reload_client_UciE0i6zes,
  check_outdated_build_client_8vK7RkfGxZ,
  index_NoOeBbAe38,
  index_HYtSsfhyFh,
  index_O6aXp1lQoC,
  datePicker_client_lfJHa2xpnu,
  layouts_OBoGUkHiof,
  leaflet_client_trb2AG60Fs,
  navigation_tracker_client_1cOcci8PxC,
  persistent_session_client_LrXxtlE9h7,
  vue3_toastify_zPoFw264mR,
  webfontloader_client_Jql8Gs55fp
]